import api from '@/services/api'
import { getOptionsString } from '@/services/api/helpers'

const createAuthor = (path, payload) => {
  return api.post(path, payload).then(({data}) => {
    return data
  })
}

const createCategories = (path, categories) => {
  return api.post(path, {categories}).then(({data}) => {
    return data
  })
}

const createKeywords = (path, keywords) => {
  return api.post(path, {keyword: keywords}).then(({data}) => {
    return data
  })
}

const createOwner = (path, {name, email}) => {
  return api.post(path, {name, email}).then(({data}) => {
    return data
  })
}

const createSeason = (podcastId, number) => {
  return api.post(`/podcasts/${podcastId}/seasons`, {number}).then(({data}) => {
    return data
  })
}

const createPodcast = (payload) => {
  return api.post('/podcasts', payload).then(({data}) => {
    return data
  })
}

const deleteCategories = (path) => {
  return api.delete(path, {}).then(({data}) => {
    return data
  })
}

const deleteKeywords = (path) => {
  return api.delete(path, {}).then(({data}) => {
    return data
  })
}

const getCreationKeys = (path) => {
  return api.get(path).then(async ({data}) => {
    return data.create && data.create.input
  })
}

const getImportProgress = (path) => {
  return api.get(path).then(({data}) => data)
}

const getPodcast = (path) => {
  return api.get(path).then(({data}) => data)
    .catch(() => {
      return false
    })
}

const getPodcastById = id => getPodcast(`/podcasts/${id}`)

const getPodcasts = (options) => {
  let optionsString = getOptionsString(options)
  let path = `/podcasts?${optionsString}`

  return api.get(path).then(async ({data}) => {
    // I removed the individual calls
    // if we find that getPodcasts isn't returning
    // certain data, we need to make sure to add it
    // to the podcasts collection in the API
    return data
  })
}

const getPodcastAnalytics = (podcastId) => {
  return api.get(`/analytics?podcast=${podcastId}`).then(({data}) => {
    return data
  })
}

const getPodcastUserPermissions = (path) => {
  return api.get(path).then(({data}) => data)
}

const getPlans = () => {
  return api.get('/podcasts').then(({data}) => {
    return data.create.input.plan.options
  })
}

const getRecentPodcasts = (podcastIds) => {
  let recentPodcasts = podcastIds.map(podcastId => {
    return getPodcast(`/podcasts/${podcastId}`)
  })

  return Promise.all(recentPodcasts)
}

const importPodcast = ({account, plan, rssFeed}) => {
  return api.post('/podcasts/import', {account, plan, rss_feed_url: rssFeed}).then(({data}) => {
    return data
  })
}

const removeAuthor = ({podcastId, authorId}) => {
  return api.delete(`/podcasts/${podcastId}/authors/${authorId}`).then(({data}) => {
    return data
  })
}

const resendImportRequest = (path) => {
  return api.post(path).then(({data}) => data)
}

const sendExitSurvey = (podcastId, surveyResponse) => {
  return api.post(`/podcasts/${podcastId}/exit_survey`, surveyResponse).then(({data}) => {
    return data
  })
}

const updateAuthor = (path, payload) => {
  return api.post(path, payload).then(({data}) => {
    return data
  })
}

const updateOwner = (path, payload) => {
  return api.post(path, payload).then(({data}) => {
    return data
  })
}

const updatePodcast = (podcastId, payload) => {
  return api.post(`/podcasts/${podcastId}`, payload).then(({data}) => {
    return data
  })
}

const verifySubdomain = (subdomain) => {
  return api.post('/podcasts/subdomains/available', {subdomain}).then(({data}) => {
    return data
  })
}

const deletePodcast = (podcastId) => {
  return api.delete(`/podcasts/${podcastId}`)
}

export default {
  createAuthor,
  createCategories,
  createKeywords,
  createOwner,
  createSeason,
  createPodcast,
  deleteCategories,
  deleteKeywords,
  deletePodcast,
  getCreationKeys,
  getImportProgress,
  getPodcast,
  getPodcastById,
  getPodcasts,
  getPodcastAnalytics,
  getPodcastUserPermissions,
  getPlans,
  getRecentPodcasts,
  importPodcast,
  removeAuthor,
  resendImportRequest,
  sendExitSurvey,
  updateAuthor,
  updateOwner,
  updatePodcast,
  verifySubdomain
}
